import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

import { getSurveyHot } from '../../../../../services/api';
/**
 * for this page
 */

class Content extends React.PureComponent {
    static propTypes = {};

    state = {
        hotList: [],
    };

    componentDidMount = () => {
        this.asyncGetSurveyHot();
    };

    asyncGetSurveyHot = async () => {
        const res = await getSurveyHot();

        // console.log(res);

        if (res) {
            this.setState({
                hotList: res,
            });
        }
    };

    render() {
        const { hotList } = this.state;

        return (
            <div className={styles.bord}>
                <div className={styles.tit}>热点调查</div>
                <ul className={styles.p10}>
                    {hotList.map(item => {
                        return (
                            <li key={item.newlink} className={styles.listItem}>
                                <p>
                                    <span className={styles.cRed3}>{item.per}%</span>的人赞同{item.title}
                                </p>
                                <p>
                                    来自调查：<span className={styles.cBlue}>
                                        <a href={item.newlink} target="_blank">
                                            {item.topic}
                                        </a>
                                    </span>
                                </p>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

export default Content;
